import React from 'react';
import Skeleton from "Components/DesignSystem/Skeleton/Skeleton";

/**
 * The category module's shimmer, on DS `Skeleton` (category Phase 1) — same
 * `{ type }` call-site API as always, so the seven consumers across the left
 * pane and the detail views did not change.
 *
 * The geometry is lifted verbatim from the retired `public/css/main.css`
 * `.skeleton.<type>` rules, including the 10px vertical rhythm the old
 * `.skeleton { margin: 10px 0 }` supplied — the loading layouts here space
 * themselves with `<br/>`s ON TOP of that margin, and dropping it would
 * visibly compress every skeleton stack in the module.
 *
 * An unknown type used to render the bare 0-height `.skeleton` box (invisible);
 * falling back to the `text` bar keeps that from silently rendering nothing.
 */
const TYPE_GEOMETRY = {
  title: { variant: "rect", width: "100%", height: "20px" },
  title25: { variant: "rect", width: "25%", height: "20px" },
  text: { variant: "rect", width: "100%", height: "0.5rem" },
  text50: { variant: "rect", width: "50%", height: "10px" },
  text25: { variant: "rect", width: "25%", height: "10px" },
  avatar: { variant: "circle", width: "100px", height: "100px" },
  thumbnail: { variant: "rect", width: "100px", height: "100px" },
  thumbnail300: { variant: "rect", width: "200px", height: "200px" },
};

const SkeletonElement = ({ type }) => {
  const geometry = TYPE_GEOMETRY[type] ?? TYPE_GEOMETRY.text;
  return (
    <Skeleton
      variant={geometry.variant}
      width={geometry.width}
      height={geometry.height}
      className="tw-my-2.5"
    />
  );
};

export default SkeletonElement;
